export const Facebook = {
  AccessToken: () => false,
  LoginManager: () => false,
  Settings: () => false,
};
